<template>
	<div class="bigcontent">
		<div class="recordOperation">
			<div class="button">
				<div class="item flex-center" :class="{ active: activeTab === 'recharge' }" @click="activeTab = 'recharge'">充值记录
				</div>
				<div class="item flex-center" :class="{ active: activeTab === 'balance' }" @click="activeTab = 'balance'">剩余额度</div>
			</div>
		</div>
		<div v-if="activeTab === 'recharge'" class="recordRegion">
			<div class="query">
				<div class="east">
					<div class="item" style="border: 1px solid #e4e7ed; border-radius: 4px;">
						<el-select v-model="queryParams.time" placeholder="请选择" clearable>
							<el-option v-for="item in timeData" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</div>
					<div class="item" style="border: 1px solid #e4e7ed; border-radius: 4px;">
						<el-select v-model="queryParams.type" placeholder="请选择" clearable>
							<el-option v-for="item in typeData" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</div>
					<div class="item">
						<el-input type="text" v-model="queryParams.text" placeholder="请输入你需要搜索的订单编号、问卷名称等" />
					</div>
				</div>
				<div class="west">
					<el-button type="primary" @click="onReset">重置</el-button>
					<el-button type="primary" @click="onSearch">查询</el-button>
				</div>
			</div>
			<div class="table">
				<el-table :data="tableData" style="width: 100%" border :cell-style="{ background: '#ffffff' }"
					:empty-text="loading ? '加载中' : '暂无数据'">
					<el-table-column prop="name" label="充值种类">
						<template slot-scope="scope">
							<span>
								{{ scope.row.orderType === 3 ? scope.row.questionnaireName : scope.row.productName }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="orderType" label="类型">
						<template slot-scope="scope">
							<span>
								{{ scope.row.orderType === 1 ? '广告点数' : 
									scope.row.orderType === 2 ? '邮件包' : 
									scope.row.orderType === 3 ? '红包' : 
									scope.row.orderType === 4 ? '短信包' : '' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="payAmount" label="金额">
					</el-table-column>
					<el-table-column prop="outTradeNo" label="订单编号">
					</el-table-column>
					<el-table-column prop="orderTime" label="有效期">
						<template slot-scope="scope">
							<span>
								{{ scope.row.orderTime }} 至 无限有效期
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="orderTime" label="订单时间">
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="prev, pager, next" :page-size="queryParams.pageSize"
						:current-page="currentPage" :total="total" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<div v-if="activeTab === 'balance'" class="balancePage">
			<div class="box" v-for="(item, index) in boxData" :key="index">
				<div class="name">{{ item.name }}</div>
				<div class="number">
					剩余：<span>{{ item.number }}</span>
					({{ item.type === 1 ? '次'
					    : item.type === 2 ? '封'
						: item.type === 3 ? '元'
						: item.type === 4 ? '条'
						: ''
					}})
				</div>
				<div :class="['button', item.type != 3 && 'active']">
					<div class="option" v-if="item.type != 3" @click="increase(item)">
						<img class="icon"
							src="https://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/wenjuan/tupian/%E6%8E%88%E6%9D%83%E5%A2%9E%E8%B4%AD%E5%A4%87%E4%BB%BD.svg"
							mode="" />
						<span>增购</span>
					</div>
					<div class="option" @click="details(item)">
						<img class="icon"
							src="https://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/wenjuan/tupian/%E8%AF%A6%E6%83%85.svg"
							mode="" />
						<span>详情</span>
					</div>
				</div>
			</div>
		</div>

		<div class="Recharge" v-if="Recharge" @click="Recharge = false,activeIndex = 0">
			<div class="content" @click.stop>
				<div class="title">{{ rechargeTitle }}
					<div class="dialogClose" @click.stop="Recharge = false,activeIndex = 0"></div>
				</div>
				<div class="tab">
					<div class="item" v-for="(item, index) in tabList" :key="item.id"
						:class="{ active: index === activeIndex }" @click.stop="onSelect(item, index)">
						<div class="number">{{ item.frequency }}{{ item.productType === 1 ? '点' : '封' }}</div>
						<div class="money">￥{{ item.currentPrice }}</div>
						<div class="originalPrice">原价{{ item.originalPrice }}</div>
						<div class="text">{{ item.discountText }}</div>
					</div>
				</div>
				<div class="button" @click.stop="buyNow">立即购买</div>
			</div>
		</div>

		<div class="Payment" v-if="PaymentShow">
			<div class="content">
				<div class="title">支付<div class="dialogClose" @click="PaymentShow = false,clearPayTimer()"></div>
				</div>
				<div class="region">
					<div class="item">应付金额：<span>￥{{ Price }}</span></div>
					<div class="item">订单编号：{{ PaymentData.outTradeNo }}</div>
					<div class="item">有效期：{{ getCurrentTime }} 至无限有效期</div>
				</div>
				<div class="code">
					<img class="brand" src="@/assets/images/123123.jpg" alt="" />
					<img class="image" :src="PaymentData.qrCodeBase64" alt="">
					<span>用微信扫一扫即可付款</span>
				</div>
			</div>
		</div>

		<div class="Details" v-if="DetailsShow">
			<div class="content">
				<div class="title">详情<div class="dialogClose" @click="DetailsShow = false"></div>
				</div>
				<div class="popupList" :class="{ noData: !popupListData.length }" v-infinite-scroll="popupMore"
					:infinite-scroll-disabled="popupListDisabled" infinite-scroll-immediate="false"
					infinite-scroll-distance="20">
					<div v-for="(item, index) in popupListData" :key="index" class="item">
						<div class="region" v-if="currentItem.type != 3">
							<div class="west">
								<div class="head">
									<div class="text">{{ item.questionnaireName }}</div>
									<span :class="['label',
													item.questionnaireType === '1' ? 'label-questionnaire' :
													item.questionnaireType === '2' ? 'label-exam' :
													item.questionnaireType === '3' ? 'label-assessment' : ''
												]">
										{{
											item.questionnaireType === '1' ? '问卷' :
											item.questionnaireType === '2' ? '考试' :
											item.questionnaireType === '3' ? '测评' : ''
										}}
									</span>
								</div>
								<div class="name">创建人：{{ item.nickname }}</div>
								<div class="time">时间：{{ item.createTime }}</div>
							</div>
							<div class="east">
								<div class="number">{{ item.freeAdUsedCount || item.successCount || 0 }}</div>
								<div class="unit">使用次数</div>
							</div>
						</div>
						
						<div class="box" v-else>
							<div class="head">
								<div class="text">{{ item.questionnaireName }}</div>
								<span :class="['label',
												item.questionnaireType === '1' ? 'label-questionnaire' :
												item.questionnaireType === '2' ? 'label-exam' :
												item.questionnaireType === '3' ? 'label-assessment' : ''
											]">
									{{
										item.questionnaireType === '1' ? '问卷' :
										item.questionnaireType === '2' ? '考试' :
										item.questionnaireType === '3' ? '测评' : ''
									}}
								</span>
							</div>
							<div class="container">
								<div class="collection">
									已领取金额:{{ item.receivedAmount }}/{{ item.totalAmount }}元
									<span @click="redCheckClaim(item)">查看领取情况</span>
								</div>
								<div class="probability">中奖概率：{{ item.probability }}%</div>
								<div class="condition">抽奖条件：{{ item.lotteryConditions }}</div>
								<div class="addTime">红包创建时间：{{ item.createTime }}</div>
								<div class="redEnvelopeType">
									红包类型：
									<img src="https://ossfastmake.mustke.com/qrCode/tupian/1766556738098.svg" />
									{{ item.packetType === 1 ? '固定金额' : '拼手气' }}
								</div>
								<div class="time">
									问卷时间：
									{{ item.questionnaireCreateTime }}
									- {{ item.ifForever === '0'
										? '永久'
										: item.questionnaireEndTime
									}}
								</div>
							</div>
							<div class="refund" :class="{disabled : item.isAmountRefunded === 1}" @click="onRefund(item)">退回剩余金额</div>
						</div>
					</div>
					<p v-if="popupList.loading" class="loading">加载中...</p>
					<p v-else-if="popupListData.length === 0" class="noMore">暂无数据</p>
					<p v-else-if="!popupList.hasMore" class="noMore">没有更多数据了</p>
				</div>
			</div>
		</div>
		
		
		<el-dialog :title="redTitle" :visible.sync="RedEnvelopeDialogVisible" width="800px"
			:before-close="handleDialogClose">
			<div class="dialogClose" @click="handleDialogClose"></div>
			<div class="redClaim" :class="{ noData: !redClaimData.length }" v-infinite-scroll="redClaimLoadMore"
				:infinite-scroll-disabled="redClaimDisabled" infinite-scroll-immediate="false" v-show="redClaimShow">
				<div class="text">
					已领取{{ redClaimDetail.claimedCount }}/{{ redClaimDetail.claimableCount }}个，
					共{{ redClaimDetail.claimedAmount }}/{{ redClaimDetail.totalAmount }}元
				</div>
				<div v-for="(item, index) in redClaimData" :key="index" class="item">
					<div class="west">
						<img :src="item.receiverAvatar" mode="" />
						<div class="region">
							<div class="name">{{ item.receiverName }}</div>
							<div class="time">{{ formatTime(item.grabTime) }}</div>
						</div>
					</div>
					<div class="east">{{ item.amount }}元</div>
				</div>
				<p v-if="redClaim.loading" class="loading">加载中...</p>
				<p v-if="!redClaim.loading && !redClaimData.length" class="noMore">暂无数据</p>
			</div>
		</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getOrder,
		getRemainingBalance,
		getAdvertisement,
		getProductEmail,
		postAdBuy,
		postEmailBuy,
		getPayment,
		getFreeAdUsage,
		getMailUsage,
		getRedPacket,
		getClaimDetail
	} from "@/api/index.js";

	export default {
		components: {

		},
		data() {
			return {
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					text: "",
					time: "",
					type: ""
				},
				timeData: [{
						label: '全部时间',
						value: ''
					},
					{
						label: '今天',
						value: '1'
					},
					{
						label: '七天内',
						value: '2'
					},
					{
						label: '十五天内',
						value: '3'
					},
					{
						label: '一个月内',
						value: '4'
					}
				],
				typeData: [{
						label: '全部类型',
						value: ''
					},
					{
						label: '广告点数',
						value: '1'
					},
					{
						label: '邮件包',
						value: '2'
					},
					{
						label: '红包',
						value: '3'
					},
					{
						label: '短信',
						value: '4'
					}
				],
				tableData: [],
				total: 0,
				currentPage: 1,
				loading: false,
				activeTab: 'recharge',
				boxData: [{
						id: 0,
						name: '免广告次数',
						type: 1,
						number: 0
					},
					{
						id: 1,
						name: '邮件发送',
						type: 2,
						number: 0
					},
					{
						id: 2,
						name: '问卷红包',
						type: 3,
						number: 0
					}
				],
				Recharge: false,
				rechargeTitle: '',
				tabList: [],
				activeIndex: 0,
				// config: {},
				PaymentShow: false,
				Price: 0,
				getCurrentTime: '',
				DetailsShow: false,
				popupListData: [],
				popupList: {
					loading: false,
					pageNum: 1,
					pageSize: 10,
					hasMore: true,
					finished: false
				},
				currentItem: null,
				RedEnvelopeDialogVisible: false,
				redTitle: '红包设置',
				redClaim: {
					loading: false,
					pageNum: 1,
					pageSize: 10,
					currentUuid: '',
					hasMore: true
				},
				redClaimShow: false,
				redClaimData: [],
				redClaimDetail: {},
				buyNowSubmitting: false
			};
		},
		created() {

		},
		computed: {
			popupListDisabled() {
				return this.popupList.loading || !this.popupList.hasMore
			},
			redClaimDisabled() {
				return this.redClaim.loading || !this.redClaim.hasMore
			},
		},
		mounted() {
			this.getData();
			this.getDefault();
		},
		watch: {

		},
		methods: {
			switchTab(tab) {
				this.activeTab = tab
			},
			getData() {
				getOrder({
						pageNum: this.queryParams.pageNum,
						pageSize: this.queryParams.pageSize,
						searchKey: this.queryParams.text || '',
						dateRangeType: this.queryParams.time || '',
						orderType: this.queryParams.type || ''
					}).then((res) => {
						this.tableData = res.rows;
						this.total = res.total;
					})
					.catch((err) => {
						console.log("err", err);
					})
			},
			onReset() {
				this.queryParams.text = "";
				this.queryParams.time = "";
				this.queryParams.type = "";
				this.currentPage = 1;
				this.queryParams.pageNum = 1;
				this.getData();
			},
			onSearch() {
				this.queryParams.pageNum = 1;
				this.currentPage = 1;
				this.getData();
			},
			handlePageChange(page) {
				this.currentPage = page;
				this.queryParams.pageNum = page;
				this.getData();
			},
			getDefault() {
				const numberMap = {
					1: 'freeAdTimes',
					2: 'emailSendTimes',
					3: 'redPacketRemainingTotalAmount'
				}
				getRemainingBalance().then(res => {
					if (res.code === 200) {
						const data = res.data
						this.boxData.forEach(item => {
							const key = numberMap[item.type]
							item.number = data[key] || 0
						})
					}
				})
			},
			onSelect(e, i) {
				this.activeIndex = i
			},
			increase(e) {
				this.Recharge = true
				const typeMap = {
					1: {
						api: getAdvertisement,
						title: '购买广告次数'
					},
					2: {
						api: getProductEmail,
						title: '购买邮箱'
					},
				}
				this.rechargeTitle = typeMap[e.type].title
				this.currentItem = e
				typeMap[e.type].api().then(res => {
						console.log('res', res)
						this.tabList = res.data
					})
					.catch(() => {

					})
			},
			details(e) {
				this.DetailsShow = true
				this.currentItem = e
				this.popupListData = []
				this.popupList = {
					loading: false,
					pageNum: 1,
					pageSize: 10,
					hasMore: true,
					finished: false
				}
				this.listGetList()
			},
			buyNow() {
				if (this.buyNowSubmitting) return
				this.buyNowSubmitting = true
				
				const typeMap = {
					1: postAdBuy,
					2: postEmailBuy
				}
				typeMap[this.currentItem.type]({
						productId: this.tabList[this.activeIndex].id,
						quantity: 1
					}).then(res => {
						// this.$message.success('下单成功')
						this.PaymentShow = true
						this.PaymentData = res.data
						let base64 = this.PaymentData.qrCodeBase64
						this.PaymentData.qrCodeBase64 = base64.startsWith('data:') ?
							base64 :
							'data:image/png;base64,' + base64
						this.Price = this.tabList[this.activeIndex].currentPrice
						this.redStartPolling(res.data.outTradeNo)
						this.getCurrentTime = new Date().toLocaleString()
					})
					.catch(() => {
						console.log('支付报错信息', err)
						this.$message.error('支付失败')
					})
					.finally(() => {
					    this.buyNowSubmitting = false
					})
			},
			redStartPolling(outTradeNo) {
				if (this.payTimer) {
					clearInterval(this.payTimer)
					this.payTimer = null
				}
				if (this.payTimeout) {
					clearTimeout(this.payTimeout)
					this.payTimeout = null
				}
				this.payTimer = setInterval(async () => {
					try {
						const res = await getPayment({
							outTradeNo
						})
						console.log('轮询返回', res)
						if (res.data === 'SUCCESS') {
							this.clearPayTimer()
							clearInterval(this.payTimer)
							this.payTimer = null
							clearTimeout(this.payTimeout)
							this.payTimeout = null
							this.PaymentShow = false
							this.Recharge = false
							this.activeIndex = 0
							this.$message.success('支付成功')
							this.getData()
							this.getDefault()  
						}

						if (res.data === 'CLOSED') {
							this.clearPayTimer()
							clearInterval(this.payTimer)
							this.payTimer = null
							clearTimeout(this.payTimeout)
							this.payTimeout = null

							this.$message.warning('订单已关闭')
						}
					} catch (err) {
						console.error('查询支付状态失败', err)
					}
				}, 3000)
				this.payTimeout = setTimeout(() => {
					this.clearPayTimer()
					if (this.payTimer) {
						clearInterval(this.payTimer)
						this.payTimer = null
					}
					this.PaymentShow = false
					this.$message.error('支付超时，请重试')
				}, 10 * 60 * 1000)
			},
			clearPayTimer() {
				if (this.payTimer) {
					clearInterval(this.payTimer)
					this.payTimer = null
				}
				if (this.payTimeout) {
					clearTimeout(this.payTimeout)
					this.payTimeout = null
				}
			},
			// 请求数据
			listGetList() {
				console.log('走了')
				if (this.popupList.loading || !this.popupList.hasMore) return
				this.popupList.loading = true
				const typeMap = {
					1: getFreeAdUsage,
					2: getMailUsage,
					3: getRedPacket,
				}
				typeMap[this.currentItem.type]({
					pageNum: this.popupList.pageNum,
					pageSize: this.popupList.pageSize
				}).then(res => {
					const list = res.rows || []
					if (list.length < this.popupList.pageSize) {
						this.popupList.hasMore = false
						this.popupList.finished = true
					}

					this.popupListData.push(...list)
					this.popupList.pageNum++
				}).finally(() => {
					this.popupList.loading = false
				})
			},
			// 滚动触底触发
			popupMore() {
				if (this.popupList.loading) return
				this.listGetList()
			},
			handleDialogClose() {
				this.clearPayTimer()
				this.RedEnvelopeDialogVisible = false
				this.redClaimShow = false
			},
			redCheckClaim(e) {
				this.RedEnvelopeDialogVisible = true
				this.redClaimData = []
				this.redClaimDetail = {}
				this.redClaimShow = true
				this.redTitle = '查看领取详情'
				this.redClaim.currentUuid = e.packetUuid
				this.redClaim.loading = false
				this.redClaim.hasMore = true
				this.redClaimGetList()
			},
			redClaimLoadMore() {
				console.log('this.redClaim.loading', this.redClaim.loading)
				if (this.redClaim.loading) return
				this.redClaimGetList()
			},
			redClaimGetList() {
				console.log('11111')
				if (this.redClaim.loading || !this.redClaim.hasMore) return
				console.log('22222')
				this.redClaim.loading = true
				getClaimDetail({
					packetUuid: this.redClaim.currentUuid,
					pageNum: this.redClaim.pageNum,
					pageSize: this.redClaim.pageSize
				}).then(res => {
					const list = res.data.items || []
			
					this.redClaimDetail = res.data
			
					if (list.length < this.redClaim.pageSize) {
						this.redClaim.hasMore = false
					}
			
					this.redClaimData.push(...list)
					this.redClaim.pageNum++
				}).finally(() => {
					this.redClaim.loading = false
				})
			},
			formatTime(time) {
				if (!time) return ''
				const date = new Date(time)
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				return `${Y}-${M}-${D} ${h}:${m}`
			},
			onRefund(e) {
				this.$message.warning('请前往小程序端进行退款操作')
			}
		},
	};
</script>

<style scoped>
	.bigcontent {
		width: calc(100% - 20px);
	}

	.bigcontent .recordOperation .button {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.bigcontent .recordOperation .button .item {
		width: 95px;
		height: 38px;
		background: #ffffff;
		border: 1px solid #3a60ff;
		border-radius: 4px;
		color: #3a60ff;
		cursor: pointer;
	}

	.bigcontent .recordOperation .button .item.active {
		background: #3a60ff;
		color: #ffffff;
	}

	.bigcontent .recordRegion,
	.bigcontent .balancePage {
		margin-top: 10px;
		background: #fff;
		padding: 15px 10px;
	}

	.bigcontent .recordRegion .query {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.bigcontent .recordRegion .query .east,
	.bigcontent .recordRegion .query .west {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.bigcontent .recordRegion .query .east .item .el-select .el-input .el-input__inner {
		width: 190px;
		border: 1px solid #e6e6e6;
	}

	.bigcontent .recordRegion .query .east .item .el-input .el-input__inner {
		width: 408px;
	}

	.bigcontent .recordRegion .query .west button {
		width: 90px;
		height: 38px;
		background: #1877ff;
		border: 1px solid #1877ff;
		border-radius: 4px;
	}

	.bigcontent .recordRegion .table {
		display: block;
		margin-top: 10px;
	}

	.bigcontent .recordRegion .table .has-gutter tr th {
		background: #f6f7fa !important;
	}

	.bigcontent .recordRegion .table .has-gutter tr th+th .cell,
	.bigcontent .recordRegion .table .el-table__row td+td .cell {
		text-align: center;
	}

	.bigcontent .balancePage {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.bigcontent .balancePage .box {
		background: #ffffff;
		border: 1px solid #dcdde0;
		border-radius: 4px;
		flex: 1;
		padding: 18px;
	}

	.bigcontent .balancePage .box .name {
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Semibold;
		font-weight: bold;
		color: #2b2f36;
	}

	.bigcontent .balancePage .box .number {
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: normal;
		color: #2b2f36;
		text-align: center;
	}

	.bigcontent .balancePage .box .number span {
		font-size: 34px;
		font-weight: bold;
		color: #3A60FF;
	}

	.bigcontent .balancePage .box .button {
		margin-top: 15px;
		padding-top: 11px;
		border-top: 1px solid #f8f8f8;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.bigcontent .balancePage .box .button::after {
		display: block;
		content: "";
		width: 2px;
		height: 17px;
		background: #d8d8d8;
		border-radius: 2px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin-top: 8px;
	}

	.bigcontent .balancePage .box .button .option {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.bigcontent .balancePage .box .button .option .icon {
		width: 15px;
		height: 15px;
		margin-right: 10px;
	}

	.bigcontent .balancePage .box:nth-child(3) .button::after {
		display: none;
	}

	.Recharge,
	.Payment,
	.Details {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1999;
		width: 100%;
		height: 100%;
		background: #00000050;
	}

	.Recharge .content {
		width: 312px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		height: auto;
		background: linear-gradient(135deg, #fffaf1, #fff1de 98%), linear-gradient(135deg, #fffaf1, #fff9f1 98%);
		border-radius: 8px;
	}

	.Recharge .content .title,
	.Payment .content .title,
	.Details .content .title {
		height: 50px;
		border-bottom: 1px solid #f2f2f2;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		font-size: 16px;
		font-family: Microsoft YaHei, Microsoft YaHei-Bold;
		font-weight: Bold;
		color: #333333;
		position: relative;
		margin-bottom: 0;
	}

	.Recharge .content .title .dialogClose,
	.Payment .content .title .dialogClose,
	.Details .content .title .dialogClose {
		top: 15px;
		right: 15px;
	}

	.dialogClose {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #8690A2;
		position: absolute;
		cursor: pointer;
	}

	.dialogClose::before,
	.dialogClose::after {
		display: block;
		content: "";
		width: 8px;
		height: 1px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(45deg);
	}

	.dialogClose::after {
		transform: translate(-50%, -50%) rotate(-45deg);
	}

	.Recharge .content {
		height: auto;
		background: linear-gradient(135deg, #fffaf1, #fff1de 98%), linear-gradient(135deg, #fffaf1, #fff9f1 98%);
		border-radius: 8px;
	}

	.Recharge .content .title {
		border: none;
		font-size: 20px;
		font-family: PingFang SC, PingFang SC-Semibold;
		font-weight: Semibold;
		color: #4b2e1c;
	}

	.Recharge .content .tab {
		margin-top: 18px;
		padding: 0 15px;
		gap: 8px;
		display: flex;
	}

	.Recharge .content .tab .item {
		display: flex;
		flex: 1;
		flex-direction: column;
		align-items: center;
		background: #ffffff;
		border: 1px solid #f9b762;
		border-radius: 8px;
		cursor: pointer;
	}

	.Recharge .content .tab .item.active {
		background: linear-gradient(180deg, #fff1de, #ffdeba);
	}

	.Recharge .content .tab .item.active .text {
		background: #FF7C5E;
		color: #fff;
		border-top: 1px solid #FF7C5E;
	}

	.Recharge .content .tab .item .number {
		font-size: 16px;
		font-weight: bold;
		color: rgba(172, 124, 94, 0.98);
		margin-top: 12px;
	}

	.Recharge .content .tab .item .money {
		font-size: 20px;
		font-weight: bold;
		color: #4b2e1c;
		margin-top: 6px;
	}

	.Recharge .content .tab .item .originalPrice {
		font-size: 10px;
		color: rgba(172, 124, 94, 0.65);
		margin-top: 4px;
		text-decoration: line-through;
	}

	.Recharge .content .tab .item .text {
		width: 100%;
		font-size: 10px;
		color: #4b2e1c;
		margin-top: 12px;
		background: #ffedd6;
		border-top: 1px solid #facb8d;
		border-radius: 0px 0px 7px 7px;
		text-align: center;
		padding: 7px 0;
	}

	.Recharge .content .button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 199px;
		height: 39px;
		background: #ff7c5e;
		border-radius: 5px;
		font-size: 15px;
		font-weight: Medium;
		color: #ffffff;
		margin: 20px auto;
		cursor: pointer;
	}

	.Payment .content {
		width: 440px;
		height: auto;
		padding-bottom: 20px;
		background: #ffffff;
		border-radius: 8px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.Payment .content .region {
		padding: 15px;
		display: flex;
		flex-direction: column;
		gap: 5px;
	}

	.Payment .content .region .item {
		font-size: 12px;
		font-weight: Regular;
		color: rgba(58, 58, 60, 0.98);
	}

	.Payment .content .region .item span {
		font-size: 18px;
		font-weight: Regular;
		color: rgba(247, 59, 66, 0.98);
	}

	.Payment .content .code {
		padding: 15px;
	}
	
	.Payment .code {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}
	
	.Payment .code .brand {
		width: 120px;
		height: auto;
	}
	
	.Payment .code .image {
		width: 180px;
		height: 180px;
		background: #ffffff;
		border: 1px solid #eaeaea;
		/* position: absolute;
		bottom: 34px;
		left: 20px; */
	}
	
	.Payment .code span {
		font-size: 16px;
	}

	.Details .content {
		width: 384px;
		height: 430px;
		background: #ffffff;
		border-radius: 8px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.Details .loading,
	.Details .noMore {
		margin: 10px auto;
		text-align: center;
	}

	.Details .popupList {
		padding: 10px;
		height: calc(100% - 70px);
		overflow-y: auto;
	}
	
	.Details .popupList .item+.item {
		margin-top: 10px;
	}
	
	.Details .popupList .item .region {
		background: #ffffff;
		border: 1px solid #ebebed;
		border-radius: 5px;
		padding: 14px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 30px;
	}
	
	.Details .popupList .item .region .west {
		flex: 1;
	}
	
	.Details .popupList .item .region .west .head {
		display: flex;
		align-items: flex-start;
		gap: 20px;
		font-size: 14px;
		font-weight: Medium;
		color: #323b5a;
		height: auto;
		border: none;
		margin-bottom: 10px;
	}
	
	.Details .popupList .item .region .west .head .label {
		background: linear-gradient(90deg,rgba(0,179,128,0.11), rgba(0,179,128,0.11));
		width: 34px;
		height: 18px;
		border-radius: 3px;
		font-size: 12px;
		font-weight: Regular;
		color: #00b380;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
	}
	
	.Details .popupList .item .region .west .name,
	.Details .popupList .item .region .west .time {
		font-size: 12px;
		font-weight: Regular;
		color: #7e7e81;
	}
	
	.Details .popupList .item .region .east {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.Details .popupList .item .region .east .number {
		font-size: 18px;
		font-weight: Medium;
		color: #323b5a;
	}
	
	.Details .popupList .item .region .east .unit {
		font-size: 12px;
		font-weight: Regular;
		color: #9b9fac;
	}
	
	.Details .popupList .item .box {
		background: #ffffff;
		border: 1px solid #ebebed;
		border-radius: 5px;
		padding: 14px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.Details .popupList .item .box .head {
		display: flex;
		align-items: flex-start;
		gap: 20px;
		font-size: 14px;
		font-weight: Medium;
		color: #323b5a;
		height: auto;
		border: none;
		margin-bottom: 10px;
		width: 100%;
	}
	
	.Details .popupList .item .box .head .label {
		background: linear-gradient(90deg,rgba(0,179,128,0.11), rgba(0,179,128,0.11));
		width: 34px;
		height: 18px;
		border-radius: 3px;
		font-size: 12px;
		font-weight: Regular;
		color: #00b380;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
	}
	
	.Details .popupList .item .box .container {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 5px;
	}
	
	.Details .popupList .item .box .container .collection span {
		color: #3A60FF;
		cursor: pointer;
	}
	
	.Details .popupList .item .box .container .collection,
	.Details .popupList .item .box .container .probability, 
	.Details .popupList .item .box .container .condition, 
	.Details .popupList .item .box .container .addTime, 
	.Details .popupList .item .box .container .redEnvelopeType, 
	.Details .popupList .item .box .container .time {
		font-size: 12px;
		font-weight: Regular;
		color: #7e7e81;
	}
	
	.Details .popupList .item .box .container .redEnvelopeType {
		display: flex;
		align-items: center;
		gap: 5px;
	}
	
	.Details .popupList .item .box .container .redEnvelopeType img {
		width: 10px;
		height: 12px;
	}
	
	.Details .popupList .item .box .refund {
		width: 122px;
		height: 38px;
		background: #3a60ff;
		border-radius: 4px;
		font-size: 14px;
		font-weight: Semibold;
		color: #ffffff;
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	
	/deep/ .el-dialog__header {
		border-bottom: 1px solid #f2f2f2;
		text-align: center;
	}
	
	/deep/ .el-dialog--center {
		border-radius: 10px;
	}
	
	.dialogClose {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #8690A2;
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}
	
	.dialogClose::before,
	.dialogClose::after {
		display: block;
		content: "";
		width: 8px;
		height: 1px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(45deg);
	}
	
	.dialogClose::after {
		transform: translate(-50%, -50%) rotate(-45deg);
	}
	
	.redClaim {
		height: 60vh;
		overflow-y: auto;
		margin-top: -15px;
	}
	
	.redClaim .text {
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: Regular;
		color: #7e7e81;
		margin-bottom: 15px;
	}
	
	.redClaim.noData {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.redClaim .item {
		position: relative;
		background: #ffffff;
		border-radius: 5px;
		box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.07);
		padding: 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.redClaim .item+.item {
		margin-top: 10px;
	}
	
	.redClaim .item .west {
		display: flex;
		align-items: center;
	}
	
	.redClaim .item .west img {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin-right: 12px;
	}
	
	.redClaim .item .region .name {
		font-size: 15px;
		font-family: PingFang SC, PingFang SC-Medium;
		font-weight: Medium;
		color: #323b5a;
	}
	
	.redClaim .item .region .time {
		margin-top: 2px;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: Regular;
		color: #7e7e81;
	}
	
	.redClaim .item .east {
		font-weight: bold;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Medium;
		font-weight: Medium;
		text-align: left;
		color: #f73b42;
	}
</style>


// WEBPACK FOOTER //
// src/views/PersonalCenter/index.vue